import { FeatureType, Menu, MenuType } from './menu-item-shared';

const overview: Menu = {
  state: 'account-overview',
  name: 'menu.overview',
  type: MenuType.Static,
  icon: 'dashboard',
};

const license: Menu = {
  state: 'licenses',
  name: 'globals.licenses',
  type: MenuType.Static,
  icon: 'verified',
};

const features: Menu = {
  state: 'features-overview',
  name: 'menu.features-overview',
  type: MenuType.Static,
  icon: 'computer',
};

const permissions: Menu = {
  state: 'permissions-overview',
  name: 'menu.permissions-overview',
  icon: 'lock_open',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.Permissions],
};

const history: Menu = {
  state: 'account-history',
  name: 'menu.balance-history',
  icon: 'history',
  type: MenuType.Static,
};

export const accountMenu: Menu = {
  state: 'account',
  name: 'menu.account',
  type: MenuType.Expandable,
  icon: 'account_circle',
  children: [overview, license, features, permissions, history],
};
